<template>
    <div class="audio">
        <div class="title">
            <img src="../../../assets/square-point.png" alt="">
            <span>音频</span>
        </div>
        <div class="con">
            <div class="con1">
                <span>
                    {{ audioTitle }}{{yysyResult}}
                    <el-icon disabled="disabled" @click.native="refreshYYSY" class="el-icon-refresh-right" style="color: #6D7278;margin-left: 5px;cursor: pointer"/>
                </span>

                <el-button @click="handleFaults">故障处理</el-button>
            </div>
            <div class="con2">
                <div @click="selectPlayer(1)" class="con2-t">原始音频</div>
                <player ref="upPlayer" title="原始音频" @selectPlayer="selectPlayer" @status-changed="playerStatusChanged" />
                <div v-if="loading" class="loading-message">加载中...</div>
                <div class="audio-btn">
                    <el-image title="停止" :src="require('@/assets/player/stop3.png')" class="player-btn" fit="contain"
                        @click="stopAudio('up')"></el-image>
                    <img alt="播放"
                        :src="this.upPlaying ? require('@/assets/player/play2.png') : require('@/assets/player/play3.png')"
                        class="player-btn" @click="playAudio('up')" />
                    <el-image title="暂停" :src="require('@/assets/player/pause3.png')" class="player-btn" fit="contain"
                        @click="pauseAudio('up')"></el-image>
                    <el-image title="上一个" :src="require('@/assets/player/prev3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(3)"></el-image>
                    <el-image title="下一个" :src="require('@/assets/player/next3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(4)"></el-image>
                    <el-image title="下载" :src="require('@/assets/player/download3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(5)"></el-image>
                </div>
            </div>


            <div class="con3">
                <div @click="selectPlayer(2)" class="con3-t">降噪音频</div>
                <player ref="downPlayer" title="降噪音频" @selectPlayer="selectPlayer" @interval-selected="intervalSelected"
                    @status-changed="playerStatusChanged" />
                <div v-if="loading" class="loading-message">加载中...</div>
                <div class="audio-btn">
                    <el-image title="停止" :src="require('@/assets/player/stop3.png')" class="player-btn" fit="contain"
                        @click="stopAudio('down')"></el-image>
                    <img title="播放" alt=""
                        :src="this.downPlaying ? require('@/assets/player/play2.png') : require('@/assets/player/play3.png')"
                        class="player-btn" fit="contain" @click="playAudio('down')">
                    <el-image title="暂停" :src="require('@/assets/player/pause3.png')" class="player-btn" fit="contain"
                        @click="pauseAudio('down')"></el-image>
                    <el-image title="上一个" :src="require('@/assets/player/prev3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(3)"></el-image>
                    <el-image title="下一个" :src="require('@/assets/player/next3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(4)"></el-image>
                    <el-image title="下载" :src="require('@/assets/player/download3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(5)"></el-image>
                    <el-image title="声纹建模" :src="require('@/assets/player/modeling3.png')" class="player-btn" fit="contain"
                        @click="clickBtn(6)"></el-image>
<!--                    <icon title="重新识别" @click="clickRefresh" class="el-icon-refresh-right" style="color: white;font-size: 18px;margin-top: 4px;margin-left: 5px;cursor: pointer;"></icon>-->
                </div>
            </div>

            <div class="con4">
                <div class="con4-left">
                    <div class="con4-t">频域图</div>
                    <dynamicSpectrum ref="dynamicSpectrum"></dynamicSpectrum>
                </div>
                <div class="con4-right">
                    <div class="con4-t">语谱图</div>
                    <spectrogramPlayer ref="spectrogramplayer"></spectrogramPlayer>
                </div>
            </div>
        </div>
        <solveDialog ref="solveDialog" @getWarningList="getWarningList"></solveDialog>
        <modeling-dialog ref="modelingDialog"></modeling-dialog>
    </div>
</template>
    
<script>
import player from '../../../components/audio-player.vue';
import dynamicSpectrum from './dynamic-spectrum.vue';
import spectrogramPlayer from './spectrogram-player.vue';
import solveDialog from '../realTime/solveDialog.vue';
import modelingDialog from "../../../components/modelingDialog.vue";

export default {
    props: ['getWarningList'],
    components: {
        modelingDialog,
        player,
        spectrogramPlayer,
        dynamicSpectrum,
        solveDialog,
    },
    data() {
        //防抖
        const debounce = (fn) => {
            let timer;
            return function () {
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    fn();
                }, 400);
            };
        };
        return {
            loading: false,
            selectedStartPos: 0,
            selectedEndPos: 0,
            yysyResult: '',
            wavUrl: '',
            audioTitle: '',
            warningData: null,
            upPlaying: false,
            downPlaying: false,
            flag: 'up',
            selectedPlayer: 0,
            music: require('../../../assets/testmusic.mp3'),
            playBack: require('../../../assets/play-back.png'),
            pause: require('../../../assets/pause.png'),
            cancalDebounce: debounce(this.initPlayer),
        };
    },
    mounted() {
        // 获取所有图标元素
        const icons = document.querySelectorAll('.audio-btn i');
        // 添加点击事件监听器
        icons.forEach(icon => {
            icon.addEventListener('click', () => {
                // 移除所有图标的激活样式
                icons.forEach(otherIcon => {
                    otherIcon.classList.remove('active');
                });
                // 为当前点击的图标添加激活样式
                icon.classList.add('active');
            });
        });

        //默认选中原始音频
        this.selectedPlayer = 1;
        // this.$refs.upPlayer.setHighlight(true);

        window.addEventListener("resize", this.cancalDebounce);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.cancalDebounce);
    },
    methods: {
        clickBtn(flag) {
            switch (flag) {
                case 1:
                    this.playAudio();
                    break;
                case 2:
                    this.pauseAudio();
                    break;
                case 3:
                    this.$emit('selectAudio', null, 'previous')
                    break;
                case 4:
                    this.$emit('selectAudio', null, 'next')
                    break;
                case 5:
                    this.downloadAudio()
                    break;
                case 6:
                    this.modeling();
                    break;
            }
        },
        modeling() {
            // this.$emit("clickModeling", this.curData);
            if (this.selectedEndPos - this.selectedStartPos < 1600) {
                this.$message.warning('请在波形中选择一个大于0.2秒的区间');
                return;
            }
            let params = {
                startPos: this.selectedStartPos,
                endPos: this.selectedEndPos,
                samplePath: "/warning/" + this.warningData.sensorId + "/" + new Date(this.warningData.warningTime).getTime() / 1000 + ".2.wav",
                edgeId: this.warningData.edgeId,
                usbPort: this.warningData.usbPort,
                sensorId: this.warningData.sensorId
            }
            this.$refs.modelingDialog.show(params);
            this.$refs.modelingDialog.title = this.audioTitle;
        },
        downloadAudio() {
            if (!this.warningData) {
                return
            }
            let a = document.createElement('a');
            a.setAttribute("download", this.warningData.warningTime + "_原始.wav");
            a.href = this.wavUrl + '.1.wav';
            a.click();
            a.setAttribute("download", this.warningData.warningTime + "_过滤.wav");
            a.href = this.wavUrl + '.2.wav';
            a.click();
        },
        playAudio(side) {
            if (side === 'up') {
                if (!this.$refs.upPlayer.waveSurfer) {
                    return
                }
                this.$refs.upPlayer.play();
                this.$refs.downPlayer.waveSurfer.pause();
                this.$refs.dynamicSpectrum.drawSpectrum(
                    this.$refs.upPlayer.waveSurfer.backend.analyser
                );
            } else {
                if (!this.$refs.downPlayer.waveSurfer) {
                    return
                }
                this.$refs.downPlayer.play();
                this.$refs.upPlayer.waveSurfer.pause();
                this.$refs.dynamicSpectrum.drawSpectrum(
                    this.$refs.downPlayer.waveSurfer.backend.analyser
                );
            }
        },
        stopAudio(side) {
            if (side === 'up') {
                if (!this.$refs.upPlayer.waveSurfer) {
                    return
                }
                this.$refs.upPlayer.stop();
            } else {
                if (!this.$refs.downPlayer.waveSurfer) {
                    return
                }
                this.$refs.downPlayer.stop();
            }
        },
        pauseAudio(side) {
            if (side === 'up') {
                if (!this.$refs.upPlayer.waveSurfer) {
                    return
                }
                this.$refs.upPlayer.waveSurfer.pause();
            } else {
                if (!this.$refs.downPlayer.waveSurfer) {
                    return
                }
                this.$refs.downPlayer.waveSurfer.pause();
            }
        },
        intervalSelected(startPos, endPos) {
            console.log('intervalSelected', startPos, endPos);
            this.selectedStartPos = startPos;
            this.selectedEndPos = endPos;
        },
        selectPlayer(flag) {
            this.selectedPlayer = flag;
            // if (flag == 1) {
            //     // this.$refs.upPlayer.setHighlight(true);
            //     this.$refs.downPlayer.setHighlight(false);
            // } else {
            //     this.$refs.upPlayer.setHighlight(false);
            //     this.$refs.downPlayer.setHighlight(true);
            // }
            if (!this.$refs.spectrogramplayer.waveSurfer) {
                return
            }
            this.$refs.spectrogramplayer.waveSurfer.load(this.wavUrl + '.' + flag + '.wav');
        },
        upHighlighted() {
            this.selectedPlayer = 1;
            // this.$refs.downPlayer.setHighlight(false);
        },
        downHighlighted() {
            this.selectedPlayer = 2;
            // this.$refs.upPlayer.setHighlight(false);
        },
        handleFaults() {
            if (this.warningData) {
                this.$refs.solveDialog.show(this.warningData.id);
            }
        },
        clear() {
            if (this.$refs.upPlayer && this.$refs.upPlayer.waveSurfer) {
                this.warningData = null
                this.audioTitle = ''
                this.$refs.upPlayer.waveSurfer.empty();
                this.$refs.downPlayer.waveSurfer.empty();
                if (this.$refs.spectrogramplayer != null && this.$refs.spectrogramplayer.waveSurfer != null) {
                    this.$refs.spectrogramplayer.waveSurfer.empty();
                }
            }
        },
        checkYYSY(warningId) {
            this.$api.yysy.evaluate({ warningId: warningId }).then(res => {
                if (res.success) {
                    this.yysyResult = res.data;
                } else {
                    this.yysyResult = '[无识别结果]';
                }
                this.audioTitle = this.warningData.position + '\u00A0\u00A0' + this.warningData.warningTime + '\u00A0\u00A0';
            });
        },
        refreshYYSY(){
            this.$api.yysy.evaluate({warningId:this.warningData.id, override:true}).then(res=>{
                if (res.success) {
                    this.yysyResult = res.data;
                } else {
                    this.yysyResult = '[无识别结果]';
                }
            })
        },
        getWarningAudio() {
            this.loading = true
            const data = this.warningData;
            this.audioTitle = data.position + '\u00A0\u00A0' + data.warningTime + '\u00A0\u00A0';
            this.checkYYSY(data.id);
            if (this.$refs.upPlayer.waveSurfer != null) {
                this.$refs.upPlayer.waveSurfer.empty();
            }
            if (this.$refs.downPlayer.waveSurfer != null) {
                this.$refs.downPlayer.waveSurfer.empty();
            }
            if (this.$refs.spectrogramplayer.waveSurfer != null) {
                this.$refs.spectrogramplayer.waveSurfer.empty();
            }
            this.wavUrl = "/api/warning/" + data.sensorId + "/" + new Date(data.warningTime).getTime() / 1000;
            const params = {
                sensorId: data.sensorId,
                warningTime: data.warningTime,
            };
            return new Promise((resolve, reject) => {
                this.$api.sensor.getWarningAudio(params).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.initPlayer();
                        resolve("success"); // 成功
                    } else {
                        resolve(res.msg); // 失败
                    }
                }).catch((error) => {
                    this.loading = false;
                    reject(error); // 处理异常
                });
            });
        },
        initPlayer() {
            this.$nextTick(() => {
                if (!this.$refs.upPlayer.waveSurfer) {
                    this.$refs.upPlayer.initPlayer();
                    this.$refs.downPlayer.initPlayer();
                }
                this.$refs.upPlayer.waveSurfer.empty();
                this.$refs.downPlayer.waveSurfer.empty();
                this.$refs.spectrogramplayer.initPlayer();
                this.$refs.upPlayer.waveSurfer.load(this.wavUrl + '.1.wav');
                this.$refs.downPlayer.waveSurfer.load(this.wavUrl + '.2.wav');
                this.$refs.spectrogramplayer.waveSurfer.load(this.wavUrl + '.1.wav');

                this.upPlaying = false;
                this.downPlaying = false;
            });
        },
        playerStatusChanged(title, status) {
            console.log('playerStatusChanged', title, status);
            if (title === '原始音频') {
                this.upPlaying = status === 'playing';
            } else if (title === '降噪音频') {
                this.downPlaying = status === 'playing';
            }
        },
    },
    computed: {},
    watch: {
    },
};
</script>
    
<style lang="less" scoped>
.audio {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title {
        margin: 8px 0 0 12px;
        display: flex;
        align-items: center;

        span {
            font-size: 16px;
            font-weight: 400;
            color: var(--titleName-color);
            margin-left: 8px;
        }
    }

    .con {
        padding: 0 13px 0 26px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .con1 {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            font-size: 16px;
            font-weight: 400;
            color: #6D7278;
        }

        /deep/.el-button {
            width: 130px;
            height: 30px;
            background: #5CEECD !important;
            border-radius: 2px !important;
            border-color: transparent !important;
            padding: 0;
        }

        /deep/.el-button--default {
            font-size: 14px !important;
            font-weight: 400;
            color: #112026 !important;
        }
    }

    .con2 {}

    .con3 {}

    .con2,
    .con3 {
        position: relative;

        .loading-message {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
            color: #44D7B6;
        }
    }

    .audio-btn {
        background-color: rgb(25, 26, 25);
        display: flex;
        justify-content: center;
        margin-top: 5px;

        i {
            font-size: 24px;
            color: #7F8488;
            cursor: pointer;
            margin-right: 20px;
        }
    }

    .audio-btn i.active {
        color: #44D7B6;
    }

    .con2-t,
    .con3-t {
        cursor: pointer;
    }

    .con2-t,
    .con3-t,
    .con4-t {
        width: 100%;
        height: 30px;
        background: var(--audio-text-bg);
        font-size: 12px;
        font-weight: 400;
        color: #b4b4b4;
        padding: 6px 0 6px 8px;
        box-sizing: border-box;
    }

    .con4 {
        display: flex;
        height: 252px;

        .con4-t {}

        .con4-left {
            margin-right: 18px;
        }

        .con4-right {}

        .con4-left,
        .con4-right {
            flex: 1;
            display: flex;
            flex-direction: column;
        }
    }
}

.audio::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid;
    border-image: linear-gradient(270deg, var(--borderImage), rgba(68, 215, 182, 1)) 1 1;
    border-image-slice: 1;
}

.player-btn {
    width: 25px;
    height: 25px;
    margin-right: 10px;
    cursor: pointer;
}
</style>
    
      


// WEBPACK FOOTER //
// src/pages/home/realTime/audio.vue